﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
/*import * as $ from "jquery";*/
import './jquery';
import "jquery-mask-plugin";    
import "jquery-validation";
/*import "jquery-validation-unobtrusive";*/
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";
import { forEach, random } from "lodash";
import Sortable from 'sortablejs';

export class DocumentsWidget {
    private IDSetter: number = 0;
    private element: HTMLElement;
    private service: Service;
    private debug: boolean = true;
    private statusBarWidget: StatusBarWidget;
    private Validator: JQueryValidation.Validator;
    private clickCounts = {};
    private selectedFiles = [];
    private uploadCounter = 0;
    private setSignatureToggle = true;

    private renderFilesUrl = null;
    private renderFormUrl = null;
    private renderMeFormUrl = null;
    private renderAccordionUrl = null;
    private submitDocumentsUrl = null;
    private createRequestSuccessMessage = null;
    private openContactsMenuUrl = null;
    private renderFormByIdUrl = null;
    private submitNewContactUrl = null;
    private editContactUrl = null;
    private deleteContactUrl = null;
    private loadPreviewUrl = null;
    private checkConsentsUrl = null;
    private scanDocumentUrl = null;
    private documentsLimit = null;
    private documentSizeTooBigText = null;
    private documentDuplicateNameText = null;
    private documentInvalidTypeText = null;
    private userConsentsBlockedText = null;
    private podpisnikiLimit = null;
    private documentSizeLimit = null;
    private steviloPodpisnikov = 1;
    private documentPositions = [];

    private signatureBoxWidth:number;
    private signatureBoxHeight: number;
    private step = 0;
    private SignaturePositionStorage: [];

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;   
        this.init();

    }

    //can only be fired once
    init() {
        var th = this;
        th.selectedFiles = [];
        th.updateDocumentPositions([]);
        this.element = $(".documents-widget")[0];
        $(this.element).find("[name=stevilo-podpisnikov]").html("0");
        this._debugging("init");          
        $(this.element).find('[data-name=btnSubmitDocsForm]').off("click");
        $(this.element).find('[data-name=btnSubmitDocsForm]').one("click", (ev) => th.submitDocuments(ev));
        $(this.element).find('[data-name=btnSubmitTemplateForm]').off("click");
        $(this.element).find('[data-name=btnSubmitTemplateForm]').on("click", (ev: Event) => th.submitTemplate(ev));

        $(this.element).find('[data-name=addPodpisnikBtn]').off("click");
        $(this.element).find('[data-name=addPodpisnikBtn]').on("click", (ev: Event) => th.onAddPodpisnik(ev));

        $(this.element).find('[data-name=addMePodpisnikBtn]').off("click");
        $(this.element).find('[data-name=addMePodpisnikBtn]').on("click", (ev: Event) => th.onAddMePodpisnik(ev));

        
        $.validator.addMethod("davcnaValidator", function (val, element, params) {
            if (val != null && val != "") {
                
            if (val.length != 8) {
                return false;
            }

            var sum = 0; for (var i = 0; i < 7; i++)
                sum += ((5 - (i % 8)) + 3) * parseInt(val[i], 10);

            sum = 11 - (sum % 11);
            if (sum == 10) sum = 0;
            if (sum != val[7]) {
                return false;
            }
            }
            return true;
        }, "Napaka");   
        $.validator.addMethod("emailValidator", function (val, element, params) { 
            if (val == "") return true;
            return  val.match(
                    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
                );  
        }, "Napaka");   

        //$.validator.setDefaults({
        //    onkeyup: function () {
        //        var originalKeyUp = $.validator.d.onkeyup;
        //        var customKeyUp = function (element, event) {
        //            if ($("#your_element")[0] === element) {
        //                return false;
        //            }
        //            else {
        //                return originalKeyUp.call(this, element, event);
        //            }
        //        }

        //        return customKeyUp;
        //    }()
        //})
        

        this.renderFilesUrl = $(this.element).data("renderFilesUrl")
        this.renderFormUrl = $(this.element).data("renderFormUrl");
        this.renderMeFormUrl = $(this.element).data("renderMeFormUrl");
        this.renderAccordionUrl = $(this.element).data("renderAccordionUrl");
        this.submitDocumentsUrl = $(this.element).data("submitDocumentsUrl");
        this.createRequestSuccessMessage = $(this.element).data("createRequestSuccess");         
        this.openContactsMenuUrl = $(this.element).data("openContactsMenuUrl");
        this.renderFormByIdUrl = $(this.element).data("renderFormByIdUrl");
        this.submitNewContactUrl = $(this.element).data("submitNewContactUrl");
        this.editContactUrl = $(this.element).data("editContactUrl");
        this.deleteContactUrl = $(this.element).data("deleteContactUrl");
        this.loadPreviewUrl = $(this.element).data("loadPreviewUrl");
        this.checkConsentsUrl = $(this.element).data("checkConsentsUrl");
        this.scanDocumentUrl = $(this.element).data("scanDocumentUrl");
        this.documentsLimit = $(this.element).data("documentsLimit");
        this.podpisnikiLimit = $(this.element).data("podpisnikiLimit");
        this.documentSizeLimit = $(this.element).data("documentSizeLimit");
        this.documentSizeTooBigText = $(this.element).data("documentSizeTooBigText");
        this.documentDuplicateNameText = $(this.element).data("documentDuplicateNameText");
        this.documentInvalidTypeText = $(this.element).data("documentInvalidTypeText");
        this.userConsentsBlockedText = $(this.element).data("userConsentsBlockedText");
        //dpi of monitor is set to 72;
        
        let dpi = parseInt($(this.element).data("signatureBoxDpi"))
        this.signatureBoxWidth = parseInt($(this.element).data("signatureBoxWidth")) / dpi * 72;
        this.signatureBoxHeight = parseInt($(this.element).data("signatureBoxHeight")) / dpi * 72;
        
        $('.nextTab').click(async function (e) {
            e.preventDefault();
            if ($(this).data("tab") == 3) {     //podpisniki
                var formStepElement = $("#docStep2");
                var formPartials = formStepElement.find("form");
                var consents = await th.CheckConsents(formPartials)
                if (!consents) {
                    return null;
                }
            }
            $('#pills-tab button[data-bs-target="#docStep' + $(this).data("tab") + '"]').tab('show');
            $('#form-tab').find('li').removeClass('active');
            $($('#form-tab').find('li')[$(this).data("tab") - 1]).addClass('active')
            if ($(this).data("tab") == 6) {
                th.loadPreview();
            }
            th.step = $(this).data("tab");
            $(".focus-step-" + $(this).data("tab")).focus();
            th._debugging("next tab click")
            if ($(this).data("tab") == 4) {     //accordion tab
                var accordions = $(th.element).find("#accordion .card").filter(function () { return $(this).find(".bi-check-lg").length < 1 })
                accordions.first().find("[data-type=accordion]").collapse('show')
                accordions.each((i,item) => {
                    $(item).find("[data-type=accordion]").one('hide.bs.collapse', function () {
                        $(accordions[i + 1]).find("[data-type=accordion]").collapse('show');
                    })
                })
            }                  
        })

        th.initNoLoad();
        th.initValidation();
        th.StepChecker();                
        $("h3").on("click", function (e) {
            if (e.ctrlKey) {
                alert(th.StepChecker());
            }
        })

        $(document).keydown(function (event) {                 
            if (!event.ctrlKey) { return }
            th.initValidation5();
        });
    }

    //function for initializing elements from partials loaded after the initial load
    initNoLoad() {
        var th = this;
        th.step = 1;
        $(this.element).find('[data-name=removePodpisnikBtn]').off("click");
        $(this.element).find('[data-name=removePodpisnikBtn]').on("click", (ev: Event) => th.onRemovePodpisnik(ev));
        $(this.element).find('input[type=file]').off("change");
        $(this.element).find('input[type=file]').on("change", (ev: Event) => th.onFilesInputChange(ev));
        $(this.element).find(".delBtn").off("click");
        $(this.element).find(".delBtn").on("click", (ev: Event) => th.onBtnDelClick(ev));
        //$(this.element).find(".delBtn").off("blur");
        //$(this.element).find(".delBtn").on("blur", (ev: Event) => th.onBtnDelBlur(ev));

        $(this.element).find('[data-name=openContactsMenu]').off("click");
        $(this.element).find('[data-name=openContactsMenu]').on("click", (ev: Event) => th.openContactsMenu(ev));

        $(this.element).find('[data-toggle="tooltip"]').tooltip({
            'delay': { show: 2000, hide: 200 },
            'trigger': 'hover',
            'placement': 'bottom'
        })
        $(this.element).find('.file-area').on('dragover', function (e) {
            var dt = e.originalEvent.dataTransfer;
            if (dt.types && (dt.types.indexOf ? dt.types.indexOf('Files') != -1 : dt.types.indexOf('Files')!==-1)) {
                $("#dragLabel").addClass("hover");
            }
        });
        $(this.element).find('#dragLabel').on('dragleave change mouseleave', function (e) {
            $("#dragLabel").removeClass("hover");
        });
        $(this.element).find('#dragLabel label').on('dragleave change mouseleave', function (e) {
            $("#dragLabel").removeClass("hover");
        });


        var el = document.getElementById('document-form-wrapper');
            var sortable = Sortable.create(el, {
                handle: ".handle-el",
                delayOnTouchOnly: false,
                direction: 'vertical',
                group: 'foo',             
                swapThreshold: 0.62,
                animation: 150
            });
        $(el).find('input').off('change');
        $(el).find('input').on('change', function (ev: Event) {
            th.StepChecker();
        });
        $(this.element).find("[data-name=SignerCompanyTaxNum], [data-name=SignerTaxNum]").off("input");
        $(this.element).find("[data-name=SignerCompanyTaxNum], [data-name=SignerTaxNum]").on("input", function (e) { th.maxInputLength($(this) as JQuery<HTMLInputElement>, 8) })

        $('input[name="showDavcna"]').off('click');
        //show it when the checkbox is clicked
        $('input[name="showDavcna"]').on('click', function () {
            if ($(this).prop('checked')) {
                $(this).closest(".document-form").find('[name="hiddenDavcna"]').show();
                $(this).closest(".document-form").find('[name="hiddenDavcna"] input').removeClass("hidden").focus();
            } else {
                $(this).closest(".document-form").find('[name="hiddenDavcna"]').hide();
                $(this).closest(".document-form").find('[name="hiddenDavcna"] input').val("").addClass("hidden");
                $(this).closest(".document-form").find('[name="hiddenDavcna"] input').removeClass('error').next('label.error').remove();
            }
        });
        this.checkPodpisnikiNumber(); 
        this.validateStep1();
        this.initValidation2();
    }

    async initValidation() {
        let th = this;       
        //step 1 validation triggering is delegated to functions that are called by the file input element
        th.initValidation2();
        th.initValidation3();
        th.initValidation4();
        th.initValidation5();
    }
    async initValidation2() {
        //step 2  
        var th = this;
        var formStepElement = $("#docStep2");
        var button = $(formStepElement).find("input[type='submit']");
        var formPartials = formStepElement.find("form");
        formPartials.each(function (i, e) {
            $.validator.setDefaults({ ignore: '.hidden' });
            var validator = $(e).validate({
                rules: {
                    SignerEmail: {
                        email: true,
                        required: true
                    },
                    SignerCompanyTaxNum: {
                        davcnaValidator: true,
                        required: true
                    }
                },
                messages: {
                    SignerEmail: {
                        email: $(e).find("[data-name=SignerEmail]").attr("errorinvalidmessage"),
                        required: $(e).find("[data-name=SignerEmail]").attr("errormessage")
                    },
                    SignerCompanyTaxNum: {
                        davcnaValidator: $(e).find("[data-name=SignerCompanyTaxNum]").attr("errormessage"),
                        required: $(e).find("[data-name=SignerCompanyTaxNum]").attr("requiredmessage")
                    }
                },
                onfocusout: function (element) {
                    if((element as any).value!="") $(element).valid();
                },    
                onfocusin: function (element) {
                    var fieldName = $(element).attr("name");    
                    validator.errorList = $.grep(validator.errorList, function (error) {
                        return $(error.element).attr("name") !== fieldName;
                    });                                                                                      
                    var errorLabel = $("label[for='" + element.id + "'].error");
                    errorLabel.hide();
                    $(this).removeClass("error").addClass("valid");
                },   
                
                onclick: false,
                onkeyup:false
            });
            $(e).find("[data-name=SignerCompanyTaxNum]").on("keyup", function () {
                var value = $(this).val().toString();
                if (value.length === 8 || value.length > 8) { 
                    validator.element($(this as HTMLElement));
                }
            })
        });
        
        
        th.validateStep2(button, formPartials);
        //$(formStepElement).find('input').on('change input', function (ev) {
        //    th.validateStep2(ev, button, formPartials);
        //});
        //this.validateStep2(button, formPartials) ;
    }
    async initValidation3() {
        //step 3    
        var th = this;
        var formStepElement = $("#docStep3");
        var button = $(formStepElement).find("input[type='submit']");
        $(formStepElement).find("form").on("change", (ev: Event) => th.validateStep3(button, formStepElement));        
    }
    async initValidation4() {
        //step 4  
        var th = this;          
        document.addEventListener('documentPositionsChanged', (event) => {
            this.validateStep4();
        });
    }
    async initValidation5() {
        //step 5
        var th = this;
        var formStepElement = $("#docStep5");
        var button = $(formStepElement).find("input[type='submit']");
        var form = formStepElement.find("form");

        $(form).validate({                 
            onclick: false,
            onkeyup:false
        }); 
        form.find("input").each(function (i, e) {
            $(e).rules("add",
                {                           
                    required: true,
                    messages: {                          
                        required: $(e).attr("requiredmessage")
                    }
                });             
        })
       
        th.validateStep5(button, formStepElement);
    }

    validateStep1() {
        var formStepElement = $("#docStep1 form");
        var button = $(formStepElement).find("input[type='submit']");
        this._debugging("Validating step 1 - Add job form");
        formStepElement.validate();
        var numberOfFiles = this.selectedFiles.length > 0;
        if (button == null) return; 
        if (!numberOfFiles) button.attr('disabled', 'disabled');
        else button.removeAttr('disabled');
        if (numberOfFiles) this._debugging("Validated step 1 - Success");
    }
    async validateStep2(button, formPartials) {
        var th = this; 
        this._debugging("Validating step 2 - Add job form");
        if (button == null) return; 

        var valid = new Array(formPartials.length).fill(false);         
        
        formPartials.each(function (i, e) {               
            $(e).find('input').off("change input");
            $(e).find('input').on('change input', function (ev) {
                
                var internalValid = $(e).validate().checkForm();
                if (internalValid) {
                    //$(e).valid();
                    valid[i] = true;
                } else {
                    valid[i] = false;
                }
                
                validateCompleteForm();
            })   
            if ($(e).validate().checkForm()) {
                valid[i] = true;
            } else {
                valid[i] = false;
            }
        });        
                   
        
        var validateCompleteForm = async () => {
            if (valid.some(element => element === false)) button.attr('disabled', 'disabled');
            else  button.removeAttr('disabled')                                                                        
            if (!valid.some(element => element === false)) this._debugging("Validated step 2 - Success");
        }
        validateCompleteForm();
    }
    validateStep3(button, formStepElement) {
        this._debugging("Validating step 3 - Add job form");
        if (button == null) return;
        var form = $(formStepElement).find("form");
        var valid = form.valid();
        if (!valid) button.attr('disabled', 'disabled');
        else button.removeAttr('disabled');
        if (valid) this._debugging("Validated step 3 - Success");        
    }
    validateStep4() {
        this._debugging("Validating step 4 - Add job form");
        var formStepElement = $("#docStep4");
        var button = $(formStepElement).find("input[type='submit']");
        if (button == null) return;
        var accordionsFilled = this.selectedFiles.length == this.documentPositions.filter(function () { return true }).length;
        if (!accordionsFilled) button.attr('disabled', 'disabled');
        else button.removeAttr('disabled');
        if (accordionsFilled) this._debugging("Validated step 4 - Success");
    }
    validateStep5(button, formStepElement) {
        this._debugging("Validating step 5 - Add job form");
        if (button == null) return;
        var form = formStepElement.find("form");
        var valid = true;    
                          
        $(form).find('input').off("change input");
        $(form).find('input').on('change input', function (ev) {
            var internalValid = $(form).validate().checkForm();
            if (internalValid) {
                $(form).valid();
                valid = true;
            } else {
                valid = false;
            }
            validateCompleteForm();
        })
        
        if ($(form).validate().checkForm()) {
            valid = true;
        } else {
            valid = false;
        }
        var validateCompleteForm = () => {
            if (!valid) button.attr('disabled', 'disabled');
            else button.removeAttr('disabled');
            if (valid) this._debugging("validated step 5 - success");
        } 
        validateCompleteForm();
    }     

    updateDocumentPosition(ordinal, position) {
        this.documentPositions[ordinal] = position;
        document.dispatchEvent(new CustomEvent('documentPositionsChanged', {}));
    }
    updateDocumentPositions(positions) {
        this.documentPositions = positions;
        document.dispatchEvent(new CustomEvent('documentPositionsChanged', { }));
    }

    async StepChecker() {
        //let th = this;
        //let formElement = $(this.element).find("#form") as JQuery<HTMLFormElement>;
        //let btn1 = $(this.element).find("[data-tab=2]"); //tab 1 next btn    
        //let btn2 = $(this.element).find("[data-tab=3]"); //tab 2 next btn
        //let btn4 = $(this.element).find("[data-tab=5]"); //tab 2 next btn
        ////var submitBtn = $(this.element).find('[data-name=btnSubmitDocsForm]'); //tab 3 submit btn
        //var x, y, z, valid = true;           
        //x = th.selectedFiles.length > 0;
        //y = await th.CheckFormValidity(formElement);
        //z = th.selectedFiles.length == th.documentPositions.filter(function () { return true }).length;
        //if (!x) btn1.attr('disabled', 'disabled');
        //else btn1.removeAttr('disabled');
        //if (!x || !y) btn2.attr('disabled', 'disabled');
        //else btn2.removeAttr('disabled');
        //if (!x || !y || !z) btn4.attr('disabled', 'disabled');
        //else btn4.removeAttr('disabled');
        //th._debugging("x: " + x+ " y: " + y+ " z: " + z);
        //if (!x || !y || !z) {
            
        //}
        //return "x: " + x + " y: " + y + " z: " + z; // return the valid status
    }
    //event na izbris dokumenta
    onBtnDelClick(ev: Event) {    
        let docId = $(ev.target).closest(".delBtn").attr("data-name");
        //this._debugging("btndel clicked: " + docId.toString());
        //this.clickCounts[docId] = this.clickCounts[docId] || 0;
        //this.clickCounts[docId]++;
        //if (this.clickCounts[docId] == 2) {
        //    this._debugging("removing: " + "#" + docId + ".doc-row");            
        let i = $(".delBtn").index($(ev.target).closest(".delBtn")[0] as HTMLElement);
        $(this.element).find("[data-name=doc-row]#"+docId).remove();
        this.selectedFiles.splice(i, 1);
        $(this.element).find("[data-name=document-accordion]")[i].remove();         //remove from tab 3
        this.updateDocumentPositions(this.documentPositions.splice(i, 1));
        //this._debugging("row deleted");
        this.StepChecker();
        
        this.validateStep1();
        this.checkDocumentsNumber();
        //}
        
    }
    //onBtnDelBlur(ev: Event) {       
    //    let docId = $(ev.target).attr("data-name");
    //    this._debugging("btndel blur: " + docId.toString())
    //    this.clickCounts[docId] = 0;
    //}
    //event na dodan dokument v fajl input
    async onFilesInputChange(ev: Event) {
        this._showLoader();
        let th = this;
        let selectedFiles = [];                
        selectedFiles = [...(ev.target as HTMLInputElement).files];
                   
        //this.indexFiles(selectedFiles);
        this._debugging(this.selectedFiles);
        this._debugging(selectedFiles);
        //filter non-pdfs
        let nonPdfs = selectedFiles.filter(file => file.type !== 'application/pdf');
        if (nonPdfs.length > 0) {
            this.statusBarWidget.setStatus(th.documentInvalidTypeText + " " + nonPdfs.map(a => a.name), "warn");
        }
        selectedFiles = selectedFiles.filter(file => file.type === 'application/pdf');

        //filter by size
        let omejitevVelikosti = this.documentSizeLimit;        
        let tooBig = selectedFiles.filter(file => file.size > omejitevVelikosti);
        if (tooBig.length > 0) {
            this.statusBarWidget.setStatus(th.documentSizeTooBigText + " " + tooBig.map(a => a.name), "warn");
        }
        selectedFiles = selectedFiles.filter(file => file.size <= omejitevVelikosti);

        // Filter for duplicate file names
        let duplicateFiles = selectedFiles.filter(file =>
            this.selectedFiles.some(existingFile => existingFile.name === file.name)
        );
        if (duplicateFiles.length > 0) {
            this.statusBarWidget.setStatus(th.documentDuplicateNameText + " " + duplicateFiles.map(a => a.name), "warn");
        }
        selectedFiles = selectedFiles.filter(file =>
            !this.selectedFiles.some(existingFile => existingFile.name === file.name)
        );

        if ((selectedFiles.length + this.selectedFiles.length) > this.documentsLimit) {
            selectedFiles = selectedFiles.slice(0, this.documentsLimit - this.selectedFiles.length);
            if (selectedFiles.length < 1) {
                ev.preventDefault();
                return;
            }
        }

        this._debugging(selectedFiles);
        /*selectedFiles.forEach(function(){  })*/

        $(this.element).find("span[data-valmsg-for='documents']").attr('hidden', 'hidden');
        let el = $(".documents-container");
        let url = this.renderFilesUrl;

        var formData = new FormData();        
        for (var i = 0; i < selectedFiles.length; i++) {
            var temp = selectedFiles[i];
            temp.idr = th.IDSetter;
            th.IDSetter++;
            this.selectedFiles.push(temp);
            formData.append('files', temp);
        }
        await this.service.PostFileAsync(formData, el, url, this.statusBarWidget);
        formData.delete('files');
        var formDataPlain = [];
        this.checkDocumentsForViruses(selectedFiles).then((scannerResults) => {
            const filesTemp = Array.from(selectedFiles);
            var kuzniPdfji = [];
            for (var i = 0; i < filesTemp.length; i++) {  
                if (filesTemp[i].name != scannerResults[i].fileId) throw new Error('Neznana napak ki je ubistvu znana');
                if (scannerResults[i].isInfected) {
                    kuzniPdfji.push({ "name": filesTemp[i].name, "value": scannerResults[i].message });
                  
                    selectedFiles.splice(i, 1);
                    $(".documents-container .doc-row").eq(-filesTemp.length + i).remove();
                    this.selectedFiles.splice(-filesTemp.length + i, 1);
                }
                else {
                    formData.append('files', filesTemp[i]);
                    formDataPlain.push(filesTemp[i]);
                }
            }
            
            if (kuzniPdfji.length > 0) {
                th.StepChecker();
                this.checkDocumentsNumber();
                this.statusBarWidget.setStatus("Virus warning:<br/> " + kuzniPdfji.map(a => a.name).join("<br/>"), "warn");
            }
            th.loadDocumentAccordions(formData, el, formDataPlain);
        })                
        
        this.checkDocumentsNumber();
        this.initNoLoad();
        this.StepChecker();
        this.validateStep1();
        this._hideLoader();
        $(ev.currentTarget).val("");
    }
    //validacija števila dovoljenih dokumentov
    checkDocumentsNumber() {
        let docElement = $(this.element).find('input[type=file]');
        if (this.selectedFiles.length >= this.documentsLimit) {
            docElement.attr("disabled", "disabled");
            docElement.parent().addClass("disabled");
        } else {
            docElement.removeAttr("disabled");
            docElement.parent().removeClass("disabled");
        }
    }

    //antivirus
    async checkDocumentsForViruses(files: Array<any>) {
        let th = this;
        th._debugging("Scanning documents.....");
        let url = th.scanDocumentUrl;

        let scanPromises = files.map((file, i) => {
            th._debugging("Scanning " + file.name)
            file.id = i;
            var formData = new FormData();
            formData.append('file', file);
            return th.service.PostFileJson(formData, url, this.statusBarWidget)
        });
        let results = await Promise.all(scanPromises);
        return results;
    }

    //nov sistem z accordioni nalouda nove dokumente
    async loadDocumentAccordions(formData, fajlEl, formDataPlain) {
        let th = this;
        let el = $(this.element).find('#accordion');
        let url = this.renderAccordionUrl;
        $('[data-name="acc-loader"]').show();
        this.service.PostFileAsync(formData, el, url, this.statusBarWidget).then(function () {
            $('[data-type="accordion"]').each(function (i, e) {
                
                if (!$(e).hasClass("rendered"))
                {

                    var ordinal = th.selectedFiles[i].idr
                    th.loadPdf(e, ordinal);
                    $(e).addClass("rendered");
                    $('[data-name=docSlider]').off('input');         //TODO
                    $('[data-name=docSlider]').on('input', function (ev: Event) {
                        var scale = $(ev.currentTarget).val();
                        $('.canvas-wrapper').css('transform', `scale(${scale}, ${scale})`);
                    }) 
                }                       
            })
            //$($(fajlEl).children).each(function (i, e) {
            $(fajlEl).find(".spinner-border").remove();
            $('[data-name="acc-loader"]').hide();
            //})
        });
        this.validateStep4();
    }

    //add podpisnkiki
    async onAddPodpisnik(ev: Event) {
        ev.preventDefault();
        if (this.steviloPodpisnikov >= this.podpisnikiLimit) return;
        this.steviloPodpisnikov++;
        let el = $(this.element).find('.document-form-wrapper');
        let url = this.renderFormUrl;
        await this.service.GetViewAsync(url, el, this.statusBarWidget);
        this.initNoLoad();
        //$(this.element).find("[data-tab=3]").attr('disabled', 'disabled');
        $(this.element).find(".bi-check-lg").removeClass("bi-check-lg").addClass("bi-arrow-down");
    }

    //add sebe v podpisnkiki
    async onAddMePodpisnik(ev: Event) {
        ev.preventDefault();
        if (this.steviloPodpisnikov >= this.podpisnikiLimit) return;
        this.steviloPodpisnikov++;
        let el = $(this.element).find('.document-form-wrapper');
        let url = this.renderMeFormUrl;
        this.checkIfPrevInputEmpty(el);
        await this.service.GetViewAsync(url, el, this.statusBarWidget);
        $("[data-name=mini-form]").last().validate();
        this.initNoLoad();
        this.StepChecker();
        $(this.element).find(".bi-check-lg").removeClass("bi-check-lg").addClass("bi-arrow-down");
    }
    //validacija števila dovoljenih podpisnikov
    checkPodpisnikiNumber() {
        $(this.element).find("[name=podpisniki-limit]").html(this.podpisnikiLimit.toString())
        $(this.element).find("[name=stevilo-podpisnikov]").html(this.steviloPodpisnikov.toString());
        let el = $(this.element).find('.add-podpisnik-btn a');
        if (this.steviloPodpisnikov >= this.podpisnikiLimit) {
            el.addClass("disabled");
        } else {
            el.removeClass("disabled");
        }
    }

    checkIfPrevInputEmpty(el: JQuery<HTMLElement>) {
        var isEmpty = true;
        el.children().last().find('input:not([type="radio"]):not([type="checkbox"])').each(function (i:number, e: HTMLInputElement) {
            if ($(e).val() != "" ) {
                isEmpty = false;
            }
        })
        this._debugging("check if empty inputs: " + isEmpty);
        if (isEmpty) {
            el.children().last().remove();
            this.steviloPodpisnikov--;
        }
    }

    async loadPdf(el, ordinal) {
        let th = this;
        this._debugging("loading pdf");
        var position: Array<{ top: number, left: number, page: number }> = [];
        var file = this.selectedFiles.find(a=>a.idr==ordinal);
        var signeeCount = $("#form").find(".form").length;
        let signatureService: SignatureWidget = new SignatureWidget($(el).find(".signature-widget") as unknown as HTMLElement, th.signatureBoxWidth, th.signatureBoxHeight);
        position = await new Promise<any>((resolve) => {
            th.setAccordionDoc(file, signatureService, signeeCount, el, ordinal)
                .then(() => signatureService.getResults())
                .then((result) => resolve(result))
        })
        
        //th.documentPositions[ordinal] = position;
        th.StepChecker();
    }

    //odstraniPodpisnika
    onRemovePodpisnik(ev: Event) {
        ev.preventDefault();
        this.steviloPodpisnikov--;
        let el = $(ev.target).closest(".document-form").remove();
        this.StepChecker();
        this.initValidation2();
        this.checkPodpisnikiNumber();
    }

    async loadPreview() {
        try {
            let th = this;
            let formElement = $(this.element).find("#form") as JQuery<HTMLFormElement>;             

            let el = $("[data-name=preview-container]");
            let url = this.loadPreviewUrl;   

            let formData = th.GetFormData(formElement);
            this._showLoader();
            //$("#signature-modal").modal('hide');
            await this.service.PostFile(formData, el, url, this.statusBarWidget);
            this._hideLoader();
        }
        catch (ex: any) {
            let err = decodeURIComponent(atob(ex.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            this.statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
        }
    }

    //validateForm(id) {
    //    var valid = $(id).validate().checkForm();
    //}
    //submit
    async submitDocuments(ev: any) {
        try {                                                                    
            ev.preventDefault();
            let th = this;
            this.scrambleNamesOnInputs();
            this._debugging("submitting documents");
            let formElement = $(this.element).find("#form") as JQuery<HTMLFormElement>;
            this._debugging(formElement);

            //validation
            var valid = true;
            $(document).on('blur keyup change', 'form input', function (e) {
                var input = $(this),
                    form = input.closest('form');
                form.valid();
            });

            var formPartials = formElement.find("[data-name=mini-form]");

            var consents = await th.CheckConsents(formPartials);
            if (!consents) {
                th.statusBarWidget.setStatus(th.userConsentsBlockedText, "bad")
                return false
            };

            formPartials.each(function (i, e) {
                $.validator.setDefaults({ ignore: '' });
                $(e).validate({
                    errorPlacement: function (error, element) {
                        return true;
                    }
                });
                $.validator.messages.required = $(e).find("[data-name=SignerEmail]").attr("errormessage");
                $(e).find("[data-name=SignerEmail]").rules("add",
                    {
                        emailValidator: true,
                        messages: {
                            emailValidator: $(e).find("[data-name=SignerEmail]").attr("errorinvalidmessage")
                        }
                    });

                //$(e).find("[data-name=SignerTaxNum]").rules("add",
                //    {
                //        davcnaValidator: true,
                //        messages: {
                //            davcnaValidator: $(e).find("[data-name=SignerTaxNum]").attr("errormessage")
                //        }
                //    });

                $(e).find("[data-name=SignerCompanyTaxNum]").rules("add",
                    {
                        davcnaValidator: true,
                        messages: {
                            davcnaValidator: $(e).find("[data-name=SignerCompanyTaxNum]").attr("errormessage")
                        }
                    });


                if (!$(e).valid()) {
                    valid = false;
                }
            });
            if (!valid) {
                return false;
            }

            if (this.selectedFiles.length < 1) {
                formElement.find("span[data-valmsg-for='documents']").removeAttr('hidden');
                this._debugging("No documents selected");
                return;
            } else {
                this._debugging(this.selectedFiles.length);
            }
            this._debugging("valid");
            this._debugging("ready to post");
            /*this._debugging(data);*/

            let el = $(".main-container");
            let url = this.submitDocumentsUrl;

            let formData = th.GetFormData(formElement);
            this._showLoader();
            $("#signature-modal").modal('hide');
            await this.service.PostFile(formData, el, url, this.statusBarWidget);
            this.statusBarWidget.setStatus(this.createRequestSuccessMessage, "ok");
            this.init();
            this.selectedFiles = [];
            this._hideLoader();
            this._debugging("posted");
        }
        catch (ex: any) {
            let err = decodeURIComponent(atob(ex.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            this.statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
        } finally {
            $(this.element).find('[data-name=btnSubmitDocsForm]').one("click", (ev)=>this.submitDocuments(ev));
        }
    }
    GetFormData(formElement: JQuery<HTMLFormElement>) {
        let th = this;
        let serializedData = [];
        formElement.find("[data-name=mini-form]").each(function (i, e) {
            serializedData.push($(e).serializeArray());
        });
        // CSRF token
        let antiForgetyToken = $('input[name="__RequestVerificationToken"]').val().toString();
        // submission token
        let submissionToken = $('#submission-token').val().toString(); 
        
        let opis = $('textarea[data-name="description"]').val().toString();
        let nivoZaupanja = $("input[name=NivoZaupanja]:checked").val().toString();
        let jobTitle = $('input[data-name="job-title"]').val().toString();
        var formData = new FormData();
        formData.append('__RequestVerificationToken', antiForgetyToken);
        formData.append('description', opis);
        formData.append('jobTitle', jobTitle);
        formData.append('submissionToken', submissionToken);
        for (let i = 0; i < serializedData.length; i++) {
            let name = serializedData[i][0].value;
            //serializedData[i][1].value;
            //let taxNumber = serializedData[i][2].value ?? "";
            let companyTaxNum = serializedData[i][serializedData[i].length-1].value ?? "";
            this._debugging({ SignerEmail: name, /*SignerTaxNum: taxNumber,*/ CompanyTaxNum: companyTaxNum });
            formData.append(`request[${i}].signerEmail`, name);
            //formData.append(`request[${i}].signerTaxNum`, taxNumber);
            formData.append(`request[${i}].signerCompanyTaxNum`, companyTaxNum);
            formData.append(`request[${i}].nivoZaupanja`, nivoZaupanja);
        }

        var position: Array<{ top: number, left: number, page: number }> = [];
        this._debugging(this.selectedFiles);
        for (var i = 0; i < this.selectedFiles.length; i++) {
            this._debugging(this.selectedFiles[i]);
            formData.append(`files[${i}].file`, this.selectedFiles[i]);
            position = th.documentPositions.filter(function () { return true })[i];
            for (var j = 0; j < position.length; j++) {
                formData.append(`files[${i}].signatures[${j}].top`, position[j].top.toString());
                formData.append(`files[${i}].signatures[${j}].left`, position[j].left.toString());
                formData.append(`files[${i}].signatures[${j}].page`, position[j].page.toString());
                formData.append(`files[${i}].signatures[${j}].ordinal`, j.toString());
            }
        }
        return formData;
    }
    async CheckFormValidity(formElement: any) {  
        //not used anymore
        //logic moved to validateStep2
    }
    async submitTemplate(ev: Event) {
        try {
            ev.preventDefault();
            let th = this;
            this._debugging("submitting template");
            let formElement = $(this.element).find("[data-name=mini-form]") as JQuery<HTMLFormElement>;
            this._debugging(formElement);

            //validation
            var valid = true;
            $(document).on('blur keyup change', 'form input', function (e) {
                var input = $(this),
                    form = input.closest('form');
                form.valid();
            });

            $(formElement).validate();

            $(formElement).find("[name=Name]").rules("add",
                {
                    required: true,
                    messages: {
                        required: "Ime predloge je obvezen podatek."
                    }
                });

            $(formElement).find("[name=SignerCount]").rules("add",
                {
                    required: true,
                    messages: {
                        required: "Vpišite število podpisnikov."
                    }
                });


            //$("form").first().valid();
            if (!formElement.valid()) {
                return false;
            }


            if (this.selectedFiles.length < 1) {
                formElement.find("span[data-valmsg-for='documents']").removeAttr('hidden');
                this._debugging("No documents selected");
                return;
            } else {
                this._debugging(this.selectedFiles.length);
            }

            let serializedData = formElement.serializeArray();

            this._debugging("valid");
            this._debugging("ready to post");
            /*this._debugging(data);*/

            let el = $(".main-container");
            let url = this.submitDocumentsUrl;
            var formData = new FormData();

            formData.append(`request.${serializedData[0].name}`, serializedData[0].value.toString());
            formData.append(`request.${serializedData[1].name}`, serializedData[1].value.toString());
            formData.append(`request.${serializedData[2].name}`, serializedData[2].value.toString());
            formData.append(`request.${serializedData[3].name}`, serializedData[3].value.toString());

            var position: Array<{ top: number, left: number, page: number }> = [];
            this._debugging(this.selectedFiles);
            for (var i = 0; i < this.selectedFiles.length; i++) {
                this._debugging(this.selectedFiles[i]);
                formData.append(`files[${i}].file`, this.selectedFiles[i]);
                if (th.setSignatureToggle == true) {
                    position = await this.getSignaturePosition(this.selectedFiles[i], null);
                    for (var j = 0; j < position.length; j++) {
                        formData.append(`files[${i}].signatures[${j}].top`, position[j].top.toString());
                        formData.append(`files[${i}].signatures[${j}].left`, position[j].left.toString());
                        formData.append(`files[${i}].signatures[${j}].page`, position[j].page.toString());
                        formData.append(`files[${i}].signatures[${j}].ordinal`, j.toString());
                    }
                }

            }
            this._showLoader();
            $("#signature-modal").modal('hide');
            await this.service.PostFile(formData, el, url, this.statusBarWidget);
            this.statusBarWidget.setStatus("Uspešno ustvarjena predloga.", "ok");
            this.init();
            this.selectedFiles = [];
            this._hideLoader();
            this._debugging("posted");
        }
        catch (ex: any) {
            let err = decodeURIComponent(atob(ex.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            this.statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
        }
    }
    getSignaturePosition(file: any, signeeCount:number): Promise<any> {
        this._debugging("setSignature");
        let th = this;
        let signatureService: SignatureWidget = new SignatureWidget($("#signature-widget") as unknown as HTMLElement, th.signatureBoxWidth, th.signatureBoxHeight);
        return new Promise((resolve) => {
            th.setModalDoc(file, signatureService, signeeCount)
                .then(() => signatureService.getResults())
                .then((result) => resolve(result))
        })
    }
    setModalDoc(data: any, signatureService: SignatureWidget, signeeCount:number) {
        this._debugging("setModalDoc");
        let th = this;
        var blob = new Blob([data], { type: "application/octetstream" });
        $("#signature-modal").modal('show');
        signatureService.initPdf(blob, signeeCount);
        return new Promise(function (resolve) {
            $(".confirmrect").on("click", function (ev: any) {                 
                resolve(true);
            })
            //$('#signature-modal').one('hide.bs.modal', function (e) {
            //    th._debugging("destroy canvas");
            //    $('#canvas').empty();
            //    $(".confirmrect").off("click");
            //    var canvas = (document.getElementById('the-canvas') as HTMLCanvasElement);
            //    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
            //    $('#prev').off("click");
            //    $('#next').off("click");
            //})
        }).catch(function (e) {
            console.log(e)
        });

    }
    setAccordionDoc(data: any, signatureService: SignatureWidget, signeeCount: number, el: HTMLElement, ordinal:number) {
        this._debugging("setting accordion");
        let th = this;
        var blob = new Blob([data], { type: "application/octetstream" });
        signatureService.initPdf(blob, signeeCount);
        return new Promise(function (resolve) {
            $(el).find(".confirmrect").off("click");
            $(el).find(".confirmrect").on("click", function (ev: any) {
                signatureService.setComplete();
                $(el).parent().find(".bi-arrow-down").removeClass("bi-arrow-down").addClass("bi-check-lg");
                //$(el).parent().find('[data-bs-toggle="collapse"]').attr('disabled', 'disabled');
                //tuki zdj dobi rezultate zato da loh spremeniš pozicijo če še enkrat odpreš accordion
                let position = signatureService.getResults();
                th.updateDocumentPosition(ordinal,position);
                th.StepChecker();
                resolve(true);  
            })
            $(el).on('show.bs.collapse', event => {
                signatureService.refreshSigneeCount($("#form").find("[data-name=mini-form]").length);                 
            })
            //$(el).find('.signature-modal').one('hide.bs.modal', function (e) {
            //    th._debugging("destroy canvas");
            //    $(el).find('.canvas').empty();
            //    $(el).find(".confirmrect").off("click");
            //    var canvas = (el.getElementsByClassName('the-canvas')[0] as HTMLCanvasElement);
            //    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
            //    $(el).find('.prev').off("click");
            //    $(el).find('.next').off("click");
            //})
        }).catch(function (e) {
            console.log(e)
        });

    }
    async openContactsMenu(ev: Event) {
        /*ev.preventDefault();*/
        let th = this;
        await this.service.GetView(th.openContactsMenuUrl, $("#contactsMenuWrapper"), this.statusBarWidget);
        $("#contacts-modal").modal("show");

        this.initCOntactMenu();

    }
    initCOntactMenu() {
        let th = this;
        $('[data-name="contactsFilter"]').off("keyup");
        $('[data-name="contactsFilter"]').on("keyup", function () {
            var value = ($(this).val() as string).toLowerCase();
            $('#contactsList li').filter(function () {
                const text = $(this).text()?.toLowerCase() || '';
                const shouldToggle = text.indexOf(value) > -1;
                $(this).toggle(shouldToggle);
                return shouldToggle;
            });
        });
        $("#newContactBtn").off("click");
        $("#newContactBtn").on("click", function (ev: Event) { th.onAddNewContact(ev); });

        $('[data-name="contactSelectBtn"]').off("click");
        $('[data-name="contactSelectBtn"]').on("click", function (ev: Event) {
            th.onAddPodpisnikFromContacts(ev);
        });
        $('[data-name="submitContactForm"]').off("click");
        $('[data-name="submitContactForm"]').on("click", function (ev: Event) {
            th.onSubmitContactForm(ev);
        });
        $('[data-name="editContact"]').off("click");
        $('[data-name="editContact"]').on("click", function (ev: Event) {
            th.onEditContact(ev);
        }); 

        $('[data-name="deleteRequest"]').off("click");
        $('[data-name="deleteRequest"]').on("click", function (ev: Event) {
            ev.preventDefault();
            $(ev.currentTarget).closest(".list-group-item").find(".confirm-slider").addClass("show");

            $('[data-name="cancelDelete"]').off("click");
            $('[data-name="cancelDelete"]').on("click", function (ev: Event) {
                ev.preventDefault();
                $(ev.currentTarget).closest(".confirm-slider").removeClass("show");
            });

            $('[data-name="deleteContact"]').off("click");
            $('[data-name="deleteContact"]').on("click", function (ev: Event) {
                ev.preventDefault();
                th.onDeleteContact(ev);
            });
        });
        
    }
    async onAddPodpisnikFromContacts(ev: Event) {
        ev.preventDefault();
        this._showLoader();
        let email = $(ev.currentTarget).parent().find('[data-name="email"]').html().trim();
        let comTaxNum = $(ev.currentTarget).parent().find('[data-name="companyTaxNum"]').html().trim();
        let description = $(ev.currentTarget).parent().find('[data-name="description"]').html().trim();
        let el = $(this.element).find('.document-form-wrapper');
        let url = this.renderFormByIdUrl;
        let data = { SignerEmail: email, SignerCompanyTaxNum: comTaxNum };
        let data2 = `{\"SignerEmail\":\"${email}\",\"SignerCompanyTaxNum\":${comTaxNum}`;
        this.checkIfPrevInputEmpty(el);
        await this.service.PostViewAsync((data), el, url, this.statusBarWidget);
        //show tax num if exists
        let newContact = el.find("[data-name=mini-form]").last();
        let compTax = newContact.find('[data-name=SignerCompanyTaxNum]').val()
        if (compTax != "") {
            newContact.find('[name=showDavcna]').prop('checked', true);
            newContact.find('[data-name=ContactCompanyTaxNumber]').val(compTax);
            newContact.find('[name="hiddenDavcna"]').show();
            newContact.find('[name="hiddenDavcna"] input').removeClass("hidden");
        }                                                    
        this.initNoLoad();
        this.StepChecker();
        $("#contacts-modal").modal("hide");
        $(this.element).find(".bi-check-lg").removeClass("bi-check-lg").addClass("bi-arrow-down-up");
    }
    async onSubmitContactForm(ev: Event) {
        ev.preventDefault();
        let formElement = $(ev.currentTarget).closest("form") as unknown as JQuery<HTMLElement>;
        this._debugging(formElement);

        //validation
        var valid = true;
        $(document).on('blur keyup change', 'form input', function (e) {
            var input = $(this),
                form = input.closest('form');
            form.valid();
        });


        $(formElement).validate();
        $(formElement).find("[name=ContactName]").rules("add",
            {
                required: true,
                messages: {
                    required: $(formElement).find("[name=ContactName]").attr("errormessage")
                }
            });
        $(formElement).find("[name=ContactEmail]").rules("add",
            {
                emailValidator: true,
                messages: {
                    emailValidator: $(formElement).find("[name=ContactEmail]").attr("errorinvalidmessage")
                }
            });          

        $(formElement).find("[name=ContactCompanyTaxNumber]").rules("add",
            {
                davcnaValidator: true,
                messages: {
                    davcnaValidator: $(formElement).find("[name=ContactCompanyTaxNumber]").attr("errormessage")
                }
            });


        if (!$(formElement).valid()) {
            valid = false;
        }



        //$("form").first().valid();
        if (!valid) {
            return false;
        }

        this._showLoader();
        
        let el = $("#contactsMenuWrapper");
        let url = this.submitNewContactUrl;
        let data = formElement.serializeArray();

        await this.service.PostObject(data, el, url, this.statusBarWidget);
        this.initCOntactMenu();
    }
    async onDeleteContact(ev: Event) {
        ev.preventDefault();
        this._showLoader();
        let hash = $(ev.currentTarget).closest(".list-group-item").find('[data-name="hashCode"]').html().trim();
        let el = $("#contactsMenuWrapper");
        let url = this.deleteContactUrl + "?hashCode=" + hash;
        let data = null;
        await this.service.PostObject(data, el, url, this.statusBarWidget);
        this.initCOntactMenu();
    }
    async onAddNewContact(ev: Event) {
        ev.preventDefault();
        let th = this;
        let el = $('#newContactForm');
        if (!el.hasClass("show")) {
            this._showLoader();
            let url = this.editContactUrl;
            await this.service.GetView(url, el, this.statusBarWidget);
            this.initCOntactMenu();
        }     
        el.on('shown.bs.collapse', function () {
            $(this).find("[name=ContactTaxNumber], [name=ContactCompanyTaxNumber]").on("input", function (e) { th.maxInputLength($(this) as JQuery<HTMLInputElement>, 8) })
            const myDiv = document.getElementById('contactsMenuWrapper');
            const isScrollable = myDiv.scrollHeight > myDiv.clientHeight;
            th._debugging("scrollHeight: " + myDiv.scrollHeight + " clientHeight: " + myDiv.clientHeight);
            if (isScrollable) {
                var listHeight: number = document.getElementById('contactsList').clientHeight as number;
                var calcHeight = listHeight - myDiv.scrollHeight + myDiv.clientHeight;
                th._debugging("calcHeight: " + calcHeight);
                $("#contactsList").css('max-height', calcHeight + 'px');
            }
        })
        el.on('hide.bs.collapse', function () {
            $("#contactsList").css('max-height', '25em');
        });
        el.collapse('toggle'); 
        
    }
    async onEditContact(ev: Event) {
        ev.preventDefault();
        this._showLoader();
        let hash = $(ev.currentTarget).parent().find('[data-name="hashCode"]').html().trim();
        let contactName = $(ev.currentTarget).parent().find('[data-name="contactName"]').html().trim();
        let email = $(ev.currentTarget).parent().find('[data-name="email"]').html().trim();
        let comTaxNum = $(ev.currentTarget).parent().find('[data-name="companyTaxNum"]').html().trim();
        let description = $(ev.currentTarget).parent().find('[data-name="description"]').html().trim();
        let el = $('#newContactForm');
        let url = this.editContactUrl + `?hashCode=${hash}&contactName=${contactName}&email=${email}&companyTaxNum=${comTaxNum}&description=${description}`;
        await this.service.GetView(url, el, this.statusBarWidget);
        if (!el.hasClass("show")) el.collapse("toggle");
        this.initCOntactMenu();
    }

    async CheckConsents(formPartials) {
        this._showLoader();
        var errorMessageVisible = $(".validationMessage").is(":visible");
        if (errorMessageVisible)
            $(".validationMessage").remove();

        //if ((ev.currentTarget as HTMLInputElement).name != "SignerEmail") return;
        //let email = (ev.currentTarget as HTMLInputElement).value;
        let parameters = [];
        if (formPartials.length < 1) return true;
        formPartials.each(function (i, e) {
            let email = ($(e).find("[data-name=SignerEmail]").val());
            if (email != undefined && email != null && email != "") {
                parameters.push(email);
            }
        })
        if (parameters.length<1) return true;
        let url = this.checkConsentsUrl;
        var result = await $.ajax({
            type: "Post",
            url: url,
            data: JSON.stringify( parameters ),
            contentType: 'application/json',
            cache: false,
            xhrFields: {
                withCredentials: true
            }
        }).fail((xhr: JQueryXHR, status: any, error: any) => {
            this.statusBarWidget.setStatus(status + ": " + this.base64Decode(xhr.getResponseHeader("err")), "bad");
            this._hideLoader();
        });
        let response = true;
        formPartials.each(function (i, e) {
            if (result[i]!=undefined && result[i] != "") {
                $(e).find("[data-name=SignerEmail]").after(`<span class="validationMessage" style="color: red;">${result[i]}</span>`);
                response = false;
                $(e).find("[data-name=SignerEmail]").on("input", function (ev) {
                    ev.currentTarget.nextSibling.remove();
                })
            }
        })
        this._hideLoader();
        return response;   
    }
    maxInputLength(el: JQuery<HTMLInputElement>, num: number) {
        if (el.val().length > num) {
            el.val(el.val().slice(0, num));
        }
    }
    _scrollToTop() {
        window.scroll({ top: 0, left: 0 });
    }
    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element, 300);
    }
    _hideLoader() {
        Loader.hideLoader(this.element);
    }
    refreshCSS = () => {
        let links = document.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            if (links[i].getAttribute('rel') == 'stylesheet') {
                let href = links[i].getAttribute('href')
                    .split('?')[0];

                let newHref = href + '?version='
                    + new Date().getMilliseconds();

                links[i].setAttribute('href', newHref);
            }
        }
    }
    scrambleNamesOnInputs() {
        $("[name='SignerEmail'], [name='SignerTaxNum'], [name='SignerCompanyTaxNum']").each(function (i,e) {
             $(e).attr("name", Math.random())
        })
    }
    base64Decode(base64: string) {
        if (!base64) return "";
        // decode base64
        let decodedError = atob(base64);
        // decode utf-8
        try {
            return decodeURIComponent(escape(decodedError));
        } catch (e) {
            return decodedError;
        }
    }
}

